import { render, staticRenderFns } from "./pswlost.vue?vue&type=template&id=682c5e9c&scoped=true&"
import script from "./pswlost.vue?vue&type=script&lang=ts&"
export * from "./pswlost.vue?vue&type=script&lang=ts&"
import style0 from "./main.css?vue&type=style&index=0&id=682c5e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c5e9c",
  null
  
)

export default component.exports